// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KJ-y","colMin":"styles_colMin__ppGI-"};